import { render, staticRenderFns } from "./Deletism.vue?vue&type=template&id=4b48fdee&"
import script from "./Deletism.vue?vue&type=script&lang=js&"
export * from "./Deletism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports